/**
 * Hook to check if privacy compliance features are enabled
 *
 * Privacy compliance features (OneTrust cookie banner) are now fully rolled out
 * and always enabled. This hook is kept for backwards compatibility.
 *
 * @returns {boolean} Whether privacy compliance features are enabled (always true)
 */
export const usePrivacyComplianceAccess = (): boolean => {
  // Privacy compliance is now always enabled
  return true
}

/**
 * Hook specifically for OneTrust cookie banner access
 *
 * @returns {boolean} Whether OneTrust cookie banner should be displayed
 */
export const useOneTrustAccess = (): boolean => usePrivacyComplianceAccess()

export default usePrivacyComplianceAccess
